import { render, staticRenderFns } from "./resource-control.vue?vue&type=template&id=55a0ba8e"
import script from "./resource-control.vue?vue&type=script&lang=ts"
export * from "./resource-control.vue?vue&type=script&lang=ts"
import style0 from "./resource-control.vue?vue&type=style&index=0&id=55a0ba8e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports